import requestV2, { RequestV2Error } from '@/service/request-v2'

export interface DingGroupConfigPayload {
  dingDeptId: string
  dingDeptName: string
  enabled: number
  groupName: string
  remark: string
  routeType: number
  secret: string
  webhook: string
}

export interface DingGroupConfig
  extends Omit<DingGroupConfigPayload, 'secret' | 'webhook'> {
  id: number | string
  routeKey: string
  secretCiphertext: string
  webhookCiphertext: string
  keyVersion: string
  createdAt: string
  updatedAt: string
  updatedBy: string
}

const url = '/main/realtime-reminder/ding-group-configs'

export async function fetchDingGroupConfigs(signal?: AbortSignal) {
  const data = await requestV2.get<unknown>({ url, signal })
  if (!Array.isArray(data)) throw new Error('钉钉群配置响应必须是数组')
  return data as DingGroupConfig[]
}

export function createDingGroupConfig(payload: DingGroupConfigPayload) {
  return requestV2.post<DingGroupConfig>({ url, data: payload })
}

export function updateDingGroupConfig(
  id: DingGroupConfig['id'],
  payload: DingGroupConfigPayload
) {
  return requestV2.put<DingGroupConfig>({ url: `${url}/${id}`, data: payload })
}

export async function deleteDingGroupConfig(id: DingGroupConfig['id']) {
  // 此接口的 Void 包装不含 data，requestV2 会原样返回该包装。
  const result = await requestV2.delete<{
    code: number
    message?: string
  } | void>({
    url: `${url}/${id}`
  })
  if (result && result.code !== 0 && result.code !== 200) {
    throw new RequestV2Error(result.message || '删除失败', 'business', {
      businessCode: result.code
    })
  }
}
